/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-09T15:06:38.736
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancePayment,
	listFinancePaymentInit,
	listFinancePaymentByAuthorizations,
	deleteFinancePayment
	
} from '@api/storagemanage/FinancePayment';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancePayment({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancePayment(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancePaymentByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancePaymentByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancePaymentInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancePaymentInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancePayment({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancePayment({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
